import React from 'react';
import { AxiosResponse } from 'axios';
import { useDispatch } from 'react-redux';
import { getFaxCount } from '@data/faxManagement/actionCreators/FaxManagementActionCreators';
import { FaxCountResponse, FaxEntry } from '@data/faxManagement/types/FaxManagement.types';
import { usePreferredUnitsWithFaxNumber } from '@utilities/hooks/usePreferredUnitsWithFaxNumber/usePreferredUnitsWithFaxNumber';

export const useGetFaxCount = () => {
	const dispatch = useDispatch();
	const [faxesWaitingCount, setFaxesWaitingCount] = React.useState<number>(0);
	const preferredUnitsWithFaxNumber = usePreferredUnitsWithFaxNumber();

	React.useEffect(() => {
		const faxNumbers = preferredUnitsWithFaxNumber.map((unit) => unit.faxNumber).join(',');
		if (!faxNumbers) {
			return;
		}

		dispatch(
			getFaxCount({
				data: { faxNumbers },
				onSuccess: ({ data }: AxiosResponse<FaxCountResponse>) => {
					const total = data.reduce(
						(sum: number, entry: FaxEntry) => sum + entry.count,
						0,
					);
					setFaxesWaitingCount(total);
				},
				asDataOrParams: 'params',
			}),
		);
	}, [dispatch, preferredUnitsWithFaxNumber]);

	return faxesWaitingCount;
};
